module.exports = __webpack_public_path__ + "img/palmmain1.6c6b289a.png";